'use client';

import { variantToLabelMap } from "../InlineNotification.data.js";
import { defaultProps } from "../InlineNotification.defaultProps.js";
import { variantToIconMap } from "./constants.js";
const emptyActions = [];
function processProps({
  onDismiss: _,
  ...props
}) {
  const variant = props.variant ?? defaultProps.variant;
  const actions = (props.actions ?? emptyActions).slice(0, 2);
  let a11yImportance = props.a11yImportance || defaultProps.a11yImportance;
  if (variant === "upsell") {
    a11yImportance = "none";
  }
  return {
    ...props,
    label: props.a11yLabel || variantToLabelMap[variant],
    // `??` not used as empty strings need to be handled here
    Icon: variantToIconMap[variant],
    variant,
    dismissible: props.dismissible ?? false,
    actions,
    a11yImportance
  };
}
export {
  processProps
};
